import React from 'react';

import { Category, Post, Tag } from '@lib/wordpress.d';
import { Article } from '@modules/craft';
import { cx } from '@emotion/css';
import Image from 'next/image';

import { hideFAQParser } from '../hideFAQParser';
import {
  getPostAuthor,
  getPostReadTime,
  getPostSubmitted,
  GetPostTitle,
  getPostTagByPostId,
  GetPostCategories,
} from '../util';

type Props = {
  post: Post;
  tags: Tag[];
  categories: Category[];
  styles: any;
};
export const BlogRight = ({ styles, post, tags, categories }: Props) => {
  return (
    <div className={styles.blog_details_right}>
      <GetPostCategories
        categoryIds={post.categories}
        categories={categories}
        style={styles.card_tag}
      />
      {getPostTagByPostId({ tags, style: styles.details_card_tag })}
      <div className={cx(styles.blog_details_wrap, styles.root)}>
        <h1 className={cx(styles.detail_title, styles.h2)}>
          <GetPostTitle post={post} />
        </h1>
        <AuthorInfo styles={styles} post={post} />
        <Article>{hideFAQParser(post.content.rendered)}</Article>
      </div>
    </div>
  );
};

const AuthorInfo = ({ styles, post }: any) => {
  return (
    <div className={cx(styles.author_info, styles.about_author)}>
      <figure className={styles.author_profile}>
        <Image
          src="/images/blog/avatars/karen_icon.png"
          alt="author profile"
          style={{ borderRadius: '50%' }}
          width={30}
          height={30}
        />
      </figure>
      <p className={cx(styles.author_name_container, styles.p)}>
        {getPostAuthor({ post })}
      </p>
      <ul className={styles.card_date_time_ul}>
        <li className={styles.card_date_time_li}>
          <span className={styles.card_icons}>
            <Image
              src="/images/blog/list/calendar.svg"
              alt="calendar"
              className={styles.card_icons_img}
              width={18}
              height={18}
            />
          </span>
          {getPostSubmitted({ post })}
        </li>
        <li className={styles.card_date_time_li}>
          <span className={styles.card_icons}>
            <Image
              src="/images/blog/list/time.svg"
              alt="time"
              className={styles.card_icons_img}
              width={18}
              height={18}
            />
          </span>
          {getPostReadTime({ post })}
        </li>
      </ul>
    </div>
  );
};
